import { useSearchParams } from "react-router-dom";
import SitesTab from "./SitesTab";
import OnSiteTab from "./OnSiteTab";
import SignLogTab from "./SignLogTab";
import HazardsTab from "./HazardsTab";
import JobHazardsTab from "./JobHazardsTab";
import IncidentsTab from "./IncidentsTab";

const TABS = [
  ["sites", "Sites", SitesTab],
  ["onsite", "Who is on site now", OnSiteTab],
  ["log", "Sign-in log", SignLogTab],
  ["hazards", "Hazards", HazardsTab],
  ["jobhazards", "Project hazards", JobHazardsTab],
  ["incidents", "Incidents", IncidentsTab],
];

export default function HsAdmin() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "sites";
  const Active = (TABS.find(t => t[0] === tab) || TABS[0])[2];
  return (
    <div className="space-y-4" data-testid="hs-admin-page">
      <h1 className="text-2xl">Health &amp; Safety</h1>
      <div className="flex gap-1 flex-wrap border-b border-neutral-800 pb-2">
        {TABS.map(([k, label]) => (
          <button key={k} onClick={() => setSp({ tab: k })} data-testid={`hs-tab-${k}`}
            className={`px-3 py-1.5 rounded text-sm ${tab === k ? "bg-silver text-black" : "hover:text-silver"}`}>{label}</button>
        ))}
      </div>
      <Active/>
    </div>
  );
}
